import { useContext } from 'react';

import { FormContext } from '../../context';

/**
 * Typed form context hook for the EditPersonaForm.
 * Returns the full extended form return including field arrays.
 */
export function useEditPersonaFormContext() {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useEditPersonaFormContext must be used within EditPersonaFormProvider');
  }
  return context;
}
